"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAccountverificationType = void 0;
var IAccountverificationType;
(function (IAccountverificationType) {
    IAccountverificationType["DEBIT_AMOUNT_VERIFICATION_DEBIT"] = "debit";
    IAccountverificationType["CREDENTIAL_VERIFICATION_CREDENTIAL"] = "credential";
})(IAccountverificationType = exports.IAccountverificationType || (exports.IAccountverificationType = {}));
